<template>
  <div class="contact-info " style="background: #c1c1c1">

    <v-row style="background: white;padding: 5px;border-radius: 5px;margin: 5px">
      <v-col cols="12">
        <v-row>


        </v-row>
      </v-col>

    </v-row>



  </div>
</template>

<script>

  import {bus} from '../../main'
  import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
  import moment from 'moment-jalaali'
  import DoughnutChart from './DoughnutChart'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'

  export default {
    data() {
      return {
        tm_operation: [],
        tm_receipts: [],
        tm_issued: [],
        from_date: '',
        to_date: '',
        dialog_report:false,
        filter_title: '',
        colors:['#ffd778','#5eb5ef', '#6fcdcd','#ff829d']
      }
    },
    components: {
      datePicker: VuePersianDatetimePicker,
      DoughnutChart
    },
    watch: {},
    mounted() {
      var user_data = JSON.parse(localStorage.getItem('zoodpayam_profile'))

      this.UserId = user_data.UserId
      this.from_date = moment().subtract(1, 'day').locale('fa').format('YYYY-MM-DD')
      this.to_date = moment().locale('fa').format('YYYY-MM-DD')
      // console.log("lastChat", this.items)
      this.get_tm_op()

      // this.getUserInfo();
      // localStorage.getItem("LastUserInfo")
    },

    methods: {
      get_type_title (id) {
        var txt = ""
        switch (id) {
          case 1:
            txt = 'دوره ای '
            break;
          case 2:
            txt = 'کارکردی '
            break;
          case 3:
            txt = 'موردی '
            break;
        }
        return txt;
      },
      get_op_title (id) {
        var txt = ""
        switch (id) {
          case 1:
            txt = 'روزانه'
            break;
          case 2:
            txt = 'ماهانه'
            break;
          case 3:
            txt = 'سالانه'
            break;
          case 4:
            txt = 'موردی'
            break;
        }
        return txt;
      },
      filter_data(list, status, title) {
        if (status == -1) {
          this.tm_operation = list
        } else {
          this.tm_operation = list.filter(x => x.LastStatusId == status)
        }

        this.filter_title = title
        this.dialog_report=true
      },
      go_back() {
        localStorage.setItem('LastUserInfo', null)
        if (!this.get_ismobile()) {
          bus.$emit('contact_chat_info_update', true)
        } else {
          this.$router.go(-1)
        }
      },

      get_tm_op() {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('zoodpayam_profile')).UserId
        var phone = localStorage.getItem('zoodpayam_phone')
        phone = phone.replace('+98', '')
        var password = localStorage.getItem('zoodpayam_password')
        const send_data = {
          FDate: this.from_date,
          TDate: this.to_date,
          UserId: user_id,
        }
        this.axios.post('https://panel.zoodkomak.com/Maintenance/GetMaintenanceRptByUserId', send_data, {})
          .then(response => {
            this.tm_operation = []
            if (response.data.Error == 0) {
              self.tm_issued = JSON.parse(response.data.Data.Items).IssuedRpt
              self.tm_receipts = JSON.parse(response.data.Data.Items).ReceiptsRpt
              var month = [
                'انجام نشده',//0
                'ارجاع شده',//1
                'انجام شده',//2
                'لغو شده',//3
                'در حال انجام',//4

              ]
              var nums = [
                self.tm_issued.filter(x => x.LastStatusId == 0).length,
                self.tm_issued.filter(x => x.LastStatusId == 1).length,
                self.tm_issued.filter(x => x.LastStatusId == 2).length,
                self.tm_issued.filter(x => x.LastStatusId == 3).length,
              ]
              self.$refs.issued_chart.months = month
              self.$refs.issued_chart.nums = nums
              self.$refs.issued_chart.colors = self.colors

              self.$refs.issued_chart.textlabel = 'وظایف ثبت شده'
              self.$refs.issued_chart.handle = (point, event)=> {
                const item = event[0]
                // console.log("iteeem222333", item.index);
                if(item.index==0){
                  self.filter_data(self.tm_issued,0,'وظایف انجام نشده توسط شما')
                }
                if(item.index==1) {
                  self.filter_data(self.tm_issued, 1, 'وظایف ارجاع شده توسط شما')
                }
                if(item.index==2){
                  self.filter_data(self.tm_issued,2,'وظایف انجام شده توسط شما')
                }
                if(item.index==3){
                  self.filter_data(self.tm_issued,3,'وظایف لغو نشده توسط شما')
                }
                if(item.index==4){
                  self.filter_data(self.tm_issued,3,'وظایف در حال انجام توسط شما')
                }
                // console.log("liiink2223333",self.$refs.issued_chart.id)
                // this.$router.push({ path: `/queue-information/${this.id[item._index]}` })
              }
              self.$refs.issued_chart.chartRender()


              var nums2 = [
                self.tm_receipts.filter(x => x.LastStatusId == 0).length,
                self.tm_receipts.filter(x => x.LastStatusId == 1).length,
                self.tm_receipts.filter(x => x.LastStatusId == 2).length,
                self.tm_receipts.filter(x => x.LastStatusId == 3).length,

              ]
              self.$refs.receipt_chart.months = month
              self.$refs.receipt_chart.nums = nums2
              self.$refs.receipt_chart.colors = self.colors
              self.$refs.receipt_chart.textlabel = 'وظایف ثبت شده'
              self.$refs.receipt_chart.handle = (point, event)=> {
                const item = event[0]
                console.log("aaaaiteeem222333", item.index);
                if(item.index==0){
                  self.filter_data(self.tm_receipts,0,'وظایف انجام نشده برای شما')
                }
                if(item.index==1) {
                  self.filter_data(self.tm_receipts, 1, 'وظایف ارجاع شده برای شما')
                }
                if(item.index==2){
                  self.filter_data(self.tm_receipts,2,'وظایف انجام شده برای شما')
                }
                if(item.index==3){
                  self.filter_data(self.tm_receipts,3,'وظایف لغو نشده برای شما')
                }
                if(item.index==4){
                  self.filter_data(self.tm_receipts,3,'وظایف در حال انجام برای شما')
                }
                console.log("aaaaliiink2223333",self.$refs.receipt_chart.id)
                // this.$router.push({ path: `/queue-information/${this.id[item._index]}` })
              }
              self.$refs.receipt_chart.chartRender()

            } else {
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          // this.errors.push(e);

        })
      },

    },

  }
</script>
